/**
* TextLayout.js
* 
* Created on 10-okt-2014, 16:42:35
* 
* @author Harm Boschloo for Ranj
* @author Reinier Feijen for Ranj
**/

import TextUtil from "../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import BrowserDetect from "../../../../lib/html5-software-library/src/ranj/util/BrowserDetect";
import { getURLParameter } from "../../../../lib/html5-software-library/src/ranj/util/URLUtil";

// Run this build task on the assets.
//<echo>Adding hook to fix text fields</echo>
//<replaceregexp byline="false" flags="gsm">
//    <regexp pattern="((this.\w+) = new cjs.Text((?!TextLayout.fixTextField).)+?^\s*$)"/>
//    <substitution expression="\1TextLayout.fixTextField\(\2\);${line.separator}"/>
//    <fileset dir="${main.src.loc}">
//        <include name="assets.*/**/*.js"/>
//    </fileset>
//</replaceregexp>

const TextLayout = {};
export default TextLayout;

// default values
TextLayout.xOffset = 0;
TextLayout.xFactor = 0;
TextLayout.yOffset = 2;
TextLayout.yFactor = .25;

TextLayout.fonts = {};
//Example font-specific parameters:  
//var paramsFontSciFly = TextLayout.fonts["scifly"] = {};
//paramsFontSciFly.yOffset = .85;
//paramsFontSciFly.yFactor = .13;

// browser specific values
if (BrowserDetect.isChrome() && BrowserDetect.version >= 71 && !BrowserDetect.isAndroid()) {
    //
}
else if (BrowserDetect.isChrome() && !BrowserDetect.isAndroid()) {
    //
}
else if (BrowserDetect.isChrome() && BrowserDetect.isAndroid()) {
    //
}
else if (BrowserDetect.isFirefox()) {
    //
}
else if (BrowserDetect.isSafari()) {
    TextLayout.yOffset = -1.05;
    TextLayout.yFactor = .07;
}
else if (BrowserDetect.isEdge()) {
    //
}
else if (BrowserDetect.isInternetExplorer()) {
    //
}
else {
    console.warn("TextLayout: Unknown browser");
}

["xOffset", "xFactor", "yOffset", "yFactor"].forEach(param => {
    const urlParamValue = parseFloat(getURLParameter(param));
    if (!isNaN(urlParamValue)) {
        TextLayout[param] = urlParamValue; 
        console.info(`[TextLayout] Using value ${urlParamValue} from url for parameter '${param}'`);
    }
});


const FONTREGEX = /(?:.*px '?)([^']*)(?:'?)/i;


TextLayout.fixTextField = (target, markTarget, logInfo) => {
    if (!(target instanceof createjs.Text)) {
        return;
    }

    if (logInfo) {
        log.info("TextLayout.fixTextField  PRE:", target.name, target.id, target.font, target.x, target.y, target.lineHeight, target.text);
    }

    if (markTarget && target.fixedTextField) {
        if (logInfo) {
            log.info("TextLayout.fixTextField ALREADY FIXED");
        }
        return;
    }
    // getting font size
    const fontSize = TextUtil.getFontSize(target);
    if (isNaN(fontSize)) {
        return;
    }

    const params = TextLayout;
    const fontname = FONTREGEX.exec(target.font)[1].toLowerCase();
    const paramsForFont = TextLayout.fonts[fontname] || {};
    const getParam = key => {
        const value = paramsForFont[key] != null ? paramsForFont[key] : params[key];
        return value;
    };

    // fix x
    const dx = getParam("xOffset") + getParam("xFactor") * fontSize;
    if (!target.textAlign || target.textAlign === "left") {
        target.x += dx;
    } else if (target.textAlign === "center") {
        target.x += dx / 2;
    }

    // fix y
    target.y += getParam("yOffset") + getParam("yFactor") * fontSize;

    // mark this target as fixed
    if (markTarget) {
        target.fixedTextField = true;
    }

    if (logInfo) {
        log.info("TextLayout.fixTextField POST:", target.name, target.id, target.font, target.x, target.y, target.lineHeight, target.text);
    }

    return target;
};
